module.exports = __webpack_public_path__ + "img/PC.899ba72d.jpg";